import {AbstractStorageModule} from "@/services/storage/AbstractStorageModule";
import {app} from "@/app";

export class Order extends AbstractStorageModule {
  order: null|Record<string, any> = null;

  get payload(): null|Record<string, any> {
    if(!this.order) return null;

    return {
      id                    : this.order?.order_id,
      email                 : this.order?.email,
      phone                 : this.order?.phone,
      shipping_country      : this.order?.shipping_address?.country,
      shipping_country_code : this.order?.shipping_address?.country_code,
      currency              : this.order?.total_price_set?.shop_money?.currency_code,
      order_total           : this.order?.total_price_set?.shop_money?.amount,
      checkout_token        : this.order?.token,
      product_ids           : this.order?.line_items?.map((item) => item.product_id),
      product_variant_ids   : this.order?.line_items?.map((item) => item?.variant_id),
    }
  }

  resolve() {
    this.order = null;

    // we can get current order only from order page
    if (app.storage.shopify.page.type === app.storage.shopify.page.types.checkoutSuccess) {
      /**
       after customer is sent to order "Thank you" page
       window.Shopify.checkout will contain order and line items data
       */
      // @ts-ignore
      this.order = window?.Shopify?.checkout ?? null;
    }



    // TODO if we want to use `/account/orders/` page we can load order via API here
  }
}
